// extracted by mini-css-extract-plugin
module.exports = {"order":"order-module__order___18ZxZ","wrap":"order-module__wrap___3BaTY","details":"order-module__details___1oNok","item":"order-module__item___3d2Ar"};